import { Component, Input, SimpleChanges } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-tanques]',
  template: `
    <td class="align-middle">
      <a routerLink="{{tanque.id}}">{{tanque?.name}}</a>
      <!-- span >{{tanque?.name}}</span -->
    </td>
    <td class="align-middle">
      <p class="mb-0" style="font-size: 14px;">{{tanque?.settlement?.name}}, Edificio:{{tanque?.building?.name}}</p>
      <p class="mb-0" style="font-size: 14px;">{{tanque?.settlement?.address}}</p>
    </td>
    <td class="align-middle text-center">{{tanque?.capacidad}} {{tanque?.unidad}}</td>
    <td class="align-middle text-center">Máx: {{tanque?.limite}} % - Mín: {{tanque?.limite_inferior}} %</td>
    <td class="align-middle text-center">
      <button class="btn btn-link text-center" routerLink="gauge/{{tanque.id}}">
        <fa-icon [icon]="icons.faGauge" size="1x" class="center-icon"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrTanquesComponent {
  @Input() tanque: any;
  @Input() permissions: any;
  @Input() settlements: any;
  @Input() profile: any;

  settlement: any = null;

  constructor(
    private store: SettlementsService,
    public icons: IconsService
  ) {}
}
